
import React, { useState, useEffect } from 'react';
import { exportToPDF, exportToExcel } from '../services/exportService';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  MenuItem,
  Snackbar,
  Alert,
} from '@mui/material';
import {
  Add as AddIcon,
  PictureAsPdf as PdfIcon,
  TableChart as ExcelIcon,
} from '@mui/icons-material';
import api from '../services/api';

function Kardex() {
  const [movimientos, setMovimientos] = useState([]);
  const [productos, setProductos] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [tipoMovimiento, setTipoMovimiento] = useState('entrada');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [busqueda, setBusqueda] = useState('');
const [filtroTipo, setFiltroTipo] = useState('');



  const [formData, setFormData] = useState({
    producto_id: '',
    cantidad: '',
    precio_unitario: '',
    motivo: '',
    documento_referencia: '',
  });

  useEffect(() => {
    cargarKardex();
    cargarProductos();
  }, []);

  const cargarKardex = async () => {
    try {
      const response = await api.get('/kardex');
      setMovimientos(response.data.data);
    } catch (error) {
      console.error('Error cargando kardex:', error);
    }
  };

  const cargarProductos = async () => {
    try {
      const response = await api.get('/productos');
      setProductos(response.data.data);
    } catch (error) {
      console.error('Error cargando productos:', error);
    }
  };

  const handleOpenDialog = (tipo) => {
    setTipoMovimiento(tipo);
    setFormData({
      producto_id: '',
      cantidad: '',
      precio_unitario: '',
      motivo: '',
      documento_referencia: '',
    });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const endpoint = tipoMovimiento === 'entrada' ? '/kardex/entrada' : '/kardex/salida';
      await api.post(endpoint, formData);
      
      setSnackbar({
        open: true,
        message: `${tipoMovimiento === 'entrada' ? 'Entrada' : 'Salida'} registrada correctamente`,
        severity: 'success'
      });
      
      handleCloseDialog();
      cargarKardex();
      cargarProductos(); // Actualizar stock en productos
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Error: ' + (error.response?.data?.message || error.message),
        severity: 'error'
      });
    }
  };

  const getColorMovimiento = (tipo) => {
    switch (tipo) {
      case 'entrada': return 'success';
      case 'salida': return 'error';
      case 'ajuste': return 'warning';
      default: return 'default';
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
    Kardex Digital - Movimientos de Inventario
  </Typography>
  <Box>
    <Button
      variant="outlined"
      startIcon={<PdfIcon />}
      onClick={() => {
        const headers = ['ID', 'Producto', 'Tipo', 'Cantidad', 'Stock Ant.', 'Stock Nuevo', 'Motivo', 'Fecha'];
        const data = movimientos.map(m => [
          m.id, m.producto_nombre, m.tipo_movimiento, m.cantidad,
          m.stock_anterior, m.stock_nuevo, m.motivo || '-',
          new Date(m.created_at).toLocaleString('es-PE')
        ]);
        exportToPDF('Reporte de Kardex - Movimientos de Inventario', headers, data, `kardex_${new Date().toISOString().split('T')[0]}`);
      }}
      sx={{ mr: 1, color: '#d32f2f', borderColor: '#d32f2f' }}
    >
      PDF
    </Button>
    <Button
      variant="outlined"
      startIcon={<ExcelIcon />}
      onClick={() => {
        const data = movimientos.map(m => ({
          'ID': m.id,
          'Producto': m.producto_nombre,
          'Código': m.codigo,
          'Tipo Movimiento': m.tipo_movimiento,
          'Cantidad': m.cantidad,
          'Stock Anterior': m.stock_anterior,
          'Stock Nuevo': m.stock_nuevo,
          'Precio Unitario': m.precio_unitario,
          'Precio Total': m.precio_total,
          'Motivo': m.motivo,
          'Documento Referencia': m.documento_referencia,
          'Fecha': new Date(m.created_at).toISOString().replace('T', ' ').substring(0, 19)
        }));
        exportToExcel(data, `kardex_${new Date().toISOString().split('T')[0]}`, 'Kardex');
      }}
      sx={{ mr: 1, color: '#388e3c', borderColor: '#388e3c' }}
    >
      Excel
    </Button>
    <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenDialog('entrada')} sx={{ backgroundColor: '#388e3c', mr: 1 }}>
      Registrar Entrada
    </Button>
    <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenDialog('salida')} sx={{ backgroundColor: '#d32f2f' }}>
      Registrar Salida
    </Button>
  </Box>
</Box>

<Paper sx={{ p: 2, mb: 2 }}>
  <Grid container spacing={2} alignItems="center">
    <Grid item xs={12} md={5}>
      <TextField
        fullWidth
        label="Buscar producto..."
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
      />
    </Grid>
    <Grid item xs={12} md={5}>
      <TextField
        fullWidth
        select
        label="Tipo de Movimiento"
        value={filtroTipo}
        onChange={(e) => setFiltroTipo(e.target.value)}
      >
        <MenuItem value="">Todos</MenuItem>
        <MenuItem value="entrada">Entradas</MenuItem>
        <MenuItem value="salida">Salidas</MenuItem>
        
      </TextField>
    </Grid>
    <Grid item xs={12} md={2}>
      <Button 
        fullWidth 
        variant="outlined" 
        onClick={() => { setBusqueda(''); setFiltroTipo(''); }}
      >
        Limpiar
      </Button>
    </Grid>
  </Grid>
</Paper>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: '#1976d2' }}>
            <TableRow>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>ID</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Producto</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Tipo</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Cantidad</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Stock Ant.</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Stock Nuevo</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Motivo</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {movimientos.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography color="textSecondary" sx={{ py: 3 }}>
                    No hay movimientos registrados. Use los botones para registrar entradas o salidas.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              movimientos
  .filter(m => {
    const coincideBusqueda = !busqueda || 
      m.producto_nombre?.toLowerCase().includes(busqueda.toLowerCase());
    const coincideTipo = !filtroTipo || m.tipo_movimiento === filtroTipo;
    return coincideBusqueda && coincideTipo;
  })
  .map((mov) => (
                <TableRow key={mov.id} hover>
                  <TableCell>{mov.id}</TableCell>
                  <TableCell>{mov.producto_nombre}</TableCell>
                  <TableCell>
                    <Chip 
                      label={mov.tipo_movimiento.toUpperCase()} 
                      color={getColorMovimiento(mov.tipo_movimiento)} 
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{mov.cantidad}</TableCell>
                  <TableCell>{mov.stock_anterior}</TableCell>
                  <TableCell>{mov.stock_nuevo}</TableCell>
                  <TableCell>{mov.motivo}</TableCell>
                  <TableCell>{new Date(mov.created_at).toLocaleString('es-PE')}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog para registrar movimiento */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ 
          color: tipoMovimiento === 'entrada' ? '#388e3c' : '#d32f2f', 
          fontWeight: 'bold' 
        }}>
          {tipoMovimiento === 'entrada' ? '📥 Registrar Entrada' : '📤 Registrar Salida'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                select
                label="Producto"
                name="producto_id"
                value={formData.producto_id}
                onChange={handleChange}
                required
              >
                {productos.map((prod) => (
                  <MenuItem key={prod.id} value={prod.id}>
                    {prod.codigo} - {prod.nombre} (Stock: {prod.stock_actual})
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Cantidad"
                name="cantidad"
                type="number"
                value={formData.cantidad}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Precio Unitario (S/)"
                name="precio_unitario"
                type="number"
                value={formData.precio_unitario}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Motivo"
                name="motivo"
                value={formData.motivo}
                onChange={handleChange}
                required
                placeholder={tipoMovimiento === 'entrada' ? 'Ej: Compra a proveedor' : 'Ej: Venta a cliente'}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Documento de Referencia"
                name="documento_referencia"
                value={formData.documento_referencia}
                onChange={handleChange}
                placeholder="Ej: Factura #001, Guía #123"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">
            Cancelar
          </Button>
          <Button 
            onClick={handleSubmit} 
            variant="contained"
            sx={{ 
              backgroundColor: tipoMovimiento === 'entrada' ? '#388e3c' : '#d32f2f' 
            }}
          >
            Registrar {tipoMovimiento === 'entrada' ? 'Entrada' : 'Salida'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar para mensajes */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Kardex;